export default "__VITE_ASSET__C$19FOs1__"